import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs/operators';

import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

import {
  CommonResponse,
  processNormal
} from '../common/response.model';

import { ErrorHandlingService } from '../common/error-handling.service';
import { Observable } from 'rxjs';




export interface PaymentStatus {
  paid: boolean;
  plan: string;
  hash: string;
}


@Injectable({
  providedIn: 'root'
})
export class PaymentService {

  constructor(
    private http: HttpClient,
    private errorHandling: ErrorHandlingService
  ) { }

  /**
   * Consultar estado del pago por hash
   */
  public getStatus(hash: string): Observable<PaymentStatus> {
    const params = new HttpParams()
      .append('hash', hash);

    return this.http.get<CommonResponse<PaymentStatus>>(
      environment.apiUrl + 'payment-status',
      {
        params
      }
    ).pipe(
      map(resp => processNormal(resp)),
      catchError(this.errorHandling.handleErrors)
    );
  }
}